import { IDataLayer, IDataLayerValue } from "../exports"

export class LayerParam {

    name: string

    layers: IDataLayer[]
    hasLayers: boolean

    defaults: IDataLayerValue[]

    layer: IDataLayer
    default: number

    min: number = 0
    max?: number

    unit: string

    expanded: boolean

    available: boolean

    constructor(private readonly isCropSupported: () => boolean) {
    }

    get showLayers(): boolean {
        return this.hasLayers || (!this.isCropSupported())
    }

    get showValues(): boolean {
        return (!this.layer || this.expanded) && this.isCropSupported()
    }

    get label(): string {
        return this.hasLayers ? "Default" : "Value"
    }

    get canExpand() {
        return this.hasLayers
    }

    get isValid() {
        return !!this.layer || !!this.default
    }

}
